import React, { useCallback, useRef } from "react";
import { FlatList, ListRenderItem } from "react-native";
import { Id } from "@teachloop/backend/_generated/dataModel";
import { SubjectTab } from "../ui/subject-tab";

function ParentLessonHistorySubjectList({
  lessonHistorySubjects,
  selectedSubjectId,
  setSelectedSubjectId,
}: {
  lessonHistorySubjects: { id: Id<"subjects">; label: string }[];
  selectedSubjectId: Id<"subjects"> | null;
  setSelectedSubjectId: (subjectId: Id<"subjects"> | null) => void;
}) {
  const tabBarRef = useRef<FlatList>(null);

  const renderItem: ListRenderItem<{ id: Id<"subjects">; label: string }> =
    useCallback(
      ({ item, index }) => (
        <SubjectTab
          onPress={() => {
            setSelectedSubjectId?.(item.id);
            setTimeout(() => {
              tabBarRef.current?.scrollToIndex({
                index,
                animated: true,
              });
            }, 100);
          }}
        >
          <SubjectTab.Title intent={item.id === selectedSubjectId ? "active" : undefined}>{item.label}</SubjectTab.Title>
        </SubjectTab>
      ),
      [setSelectedSubjectId, selectedSubjectId]
    );

  return (
    <FlatList
      ref={tabBarRef}
      horizontal
      showsHorizontalScrollIndicator={false}
      data={lessonHistorySubjects}
      contentContainerClassName="gap-4"
      renderItem={renderItem}
    />
  );
}

export default ParentLessonHistorySubjectList;
